import script from "./FichaEmpleado.vue?vue&type=script&setup=true&lang=js"
export * from "./FichaEmpleado.vue?vue&type=script&setup=true&lang=js"

import "./FichaEmpleado.vue?vue&type=style&index=0&id=1491a82e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1491a82e"]])

export default __exports__